import type React from "react";
import { useEffect, useRef } from "react";
import { twMerge } from "tailwind-merge";

interface DropdownProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

export const Dropdown: React.FC<DropdownProps> = ({
  isOpen,
  onClose,
  children,
  className = "",
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        !(event.target as HTMLElement).closest(".dropdown-toggle")
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={dropdownRef}
      className={twMerge(
        "absolute right-0 z-40 mt-3 rounded-[10px] border border-[var(--rule)] bg-[var(--card)] shadow-[var(--shadow)] lg:mt-2",
        className,
      )}
      style={{ marginRight: "-20px" }}
    >
      {children}
    </div>
  );
};
